module.exports = __webpack_public_path__ + "img/ezgif.com-apng-maker-1.bd1be60e.png";